// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 950 ? "4ae8876b" : chunkId) + "." + {"686":"7662cb39196afa1a","950":"b9c9e94fa4af0312"}[chunkId] + ".js";
};